import type { MaybeRef } from 'vue';
import { computed, unref } from 'vue';
import { useAsyncState } from '@vueuse/core';
import { countries } from '@getaccept/lib-shared/src/countries/constants/countries';
import LocationService from '../../location/location.service';

export const useGeoLocation = (entityCountryCode?: MaybeRef<string>) => {
  const { state: geoLocation, ...query } = useAsyncState(LocationService.getGeoLocation, null);

  const countryCode = computed(
    () => unref(entityCountryCode) || geoLocation.value?.country_code || 'US'
  );

  const countryName = computed(
    () => geoLocation.value?.country_name || countries[countryCode.value]
  );

  return { ...query, countryCode, geoLocation, countryName };
};
